import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';
import { useTheme } from '@mui/material';

const RssIcon: React.FC<IconProps> = ({ size, color, secondaryColor }) => {
  const theme = useTheme();
  return (
    <svg xmlns="http://www.w3.org/2000/svg" xmlSpace="preserve" viewBox="0 0 455.731 455.731" width={size} height={size} data-testid="rss-icon">
      <path
        d="M0 0h455.731v455.731H0z"
        style={{
          fill: color ? secondaryColor || theme.palette.primary.main : '#f78422',
        }}
      />
      <path
        d="M296.208 159.16C234.445 97.397 152.266 63.382 64.81 63.382v64.348c70.268 0 136.288 27.321 185.898 76.931 49.609 49.61 76.931 115.63 76.931 185.898h64.348c-.001-87.456-34.016-169.636-95.779-231.399z"
        style={{
          fill: color ? color : '#fff',
        }}
      />
      <path
        d="M64.143 172.273v64.348c84.881 0 153.938 69.056 153.938 153.939h64.348c0-120.364-97.922-218.287-218.286-218.287z"
        style={{
          fill: color ? color : '#fff',
        }}
      />
      <circle
        cx={109.833}
        cy={346.26}
        r={46.088}
        style={{
          fill: color ? color : '#fff',
        }}
      />
    </svg>
  );
};

export default RssIcon;
